import { useTheme } from "@/lib/ThemeContext";
import { useAuth } from "@/lib/AuthContext";
import { ShieldAlert } from "lucide-react";
import { TwoFactorEnrol } from "@/components/settings/TwoFactorCard";

// Bundle S-1: the owner account must enrol in 2FA before using the app.
export default function TwoFactorEnrolGate() {
  const { tokens: t } = useTheme();
  const { refreshUser, logout } = useAuth();

  return (
    <div className="fixed inset-0 z-[1200] flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.85)", backdropFilter: "blur(12px)" }} data-testid="twofa-owner-gate">
      <div className="w-full max-w-md rounded-2xl p-6 space-y-4" style={{ background: t.bgPrimary, border: `1px solid ${t.borderColor}` }}>
        <div className="flex items-center gap-2">
          <ShieldAlert className="h-5 w-5" style={{ color: t.accent }} />
          <h2 className="text-base md:text-lg font-bold" style={{ color: t.textPrimary }}>Secure the owner account</h2>
        </div>
        <p className="text-sm" style={{ color: t.textMuted }}>
          Two-factor authentication is required for the owner account. Set it up now — it takes about a minute.
        </p>
        <TwoFactorEnrol onEnrolled={refreshUser} t={t} />
        <button type="button" onClick={logout} className="text-xs hover:underline" style={{ color: t.textMuted }} data-testid="twofa-gate-logout">Sign out instead</button>
      </div>
    </div>
  );
}
